import * as React from "react"
import { Button } from "@progress/kendo-react-buttons"
import { Tooltip } from "@progress/kendo-react-tooltip"

export const ActionsCell = (props) => {
  const { dataItem, confirmAccept, confirmReject } = props

  return (
    <td>
      <Tooltip anchorElement="target" parentTitle={true}>
        <Button
          onClick={(e) => confirmAccept(e, dataItem)}
          title="Accept Request"
          style={{ fontSize: "0.6rem", color:"lightgreen" }}
        >
          <i className="fas fa-check-circle" />
        </Button>
        <Button
          onClick={(event) => confirmReject(event, dataItem)}
          title="Reject Request"
          style={{ fontSize: "0.6rem", color:"red" }}
        >
          <i className="fas fa-times-circle" />
        </Button>
      </Tooltip>
    </td>
  )
}

export default ActionsCell
